import "../css/styles.css";
import React, {Component} from "react";
import moment from 'moment';
import DesktopBreakpoint from "../components/responsive_utilities/desktop_breakpoint";
import TelevisionBreakpoint from "../components/responsive_utilities/television_breakpoint";
import TabletBreakpoint from "../components/responsive_utilities/tablet_breakpoint";
import PhoneBreakpoint from "../components/responsive_utilities/phone_breakpoint";
const logo = require('../media/sancoIcon_trans.png');

var firebase = require('firebase/app');
require('firebase/database');
require('firebase/auth');

class TeamReg extends Component {
  
  constructor() {
    super();
    this.state = {
      user: {},
      tournament: {},
      tournamentId: '',
      teamName: '',
      boatName: '',
      teamCaptName: '',
      teamCaptEmail: '',
      teamCaptUid: '',
      role: ''
      
    }
    this.ref = firebase.database().ref('tournaments');
    this.handleTeamNameChange = this.handleTeamNameChange.bind(this);
    this.handleBoatNameChange = this.handleBoatNameChange.bind(this);
    this.handleTeamCaptNameChange = this.handleTeamCaptNameChange.bind(this);
    this.handleTeamCaptEmailChange = this.handleTeamCaptEmailChange.bind(this);
    this.handleRoleChange = this.handleRoleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.getCurrentUser = this.getCurrentUser.bind(this);
  }
  
  componentWillMount() {
    this.ref.on('value', this.handleTournamentUpdate);
  }
  
  componentWillUnmount() {
    this.ref.off
  }
  
  
  handleTournamentUpdate = (snapshot) => {
      snapshot.forEach((snap) => {
          if(snap.key === this.props.match.params.tourId) {
             this.setState({
                tournament: snap.val(),
                tournamentId: snap.key
              });
         }
      })
  }
  
  getCurrentUser() {
      firebase.auth().onAuthStateChanged(function(user) {
      if (user) {
      } else {
        // No user is signed in.
      }
    });
  }
  
  handleTeamNameChange(event) {
      this.setState({
          teamName: event.target.value
      })
  }

  handleBoatNameChange(event) {
      this.setState({
          boatName: event.target.value
      })
  }

  handleTeamCaptNameChange(event) {
      this.setState({
          teamCaptName: event.target.value
      })
  }

  handleTeamCaptEmailChange(event) {
      this.setState({
          teamCaptEmail: event.target.value
      })
  }

  handleRoleChange(event) {
      this.setState({
          role: event.target.value
      })
  }

  handleSubmit(data) {
      this.setState({
          
      })
  }


  render () {
    return (
      <div className="front-bkg-phone">
        <TelevisionBreakpoint>
          
        </TelevisionBreakpoint>
        <DesktopBreakpoint>
          
        </DesktopBreakpoint>
        <TabletBreakpoint>
          
        </TabletBreakpoint>
        <PhoneBreakpoint> 
        <div className="phoneContainer">
            <div className="header">
                <div style={{
                  width: '150px', 
                  height: '120px', 
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: '50% 0%',
                  backgroundImage: 'url('+ this.state.tournament.logoUri +')'}} />
            </div>
            <div className="details-name-phone">{this.state.tournament.name}</div>
            <div className="details-venue-phone">{this.state.tournament.venue}</div>
            <div className="details-text-phone">Capt. Meeting Location: {this.state.tournament.captMeetingLoc}</div>
            <div className="details-meetTime-phone">Capt. Meeting Time: {this.state.meetingTime}</div>
            {this.state.tournament.day1Date ? <div className="details-text-phone">Day 1 Lines In: { moment.utc(new Date(this.state.tournament.day1Date)).format('lll') }</div>: null}
            {this.state.tournament.day2Date ? <div className="details-text-phone">Day 2 Lines In: { moment.utc(new Date(this.state.tournament.day2Date)).format('lll') }</div> : null}
            {this.state.tournament.day3Date ? <div className="details-text-phone">Day 3 Lines In: { moment.utc(new Date(this.state.tournament.day3Date)).format('lll') }</div>: null}
            {this.state.tournament.day4Date ? <div className="details-text-phone">Day 4 Lines In: { moment.utc(new Date(this.state.tournament.day4Date)).format('lll') }</div> : null}
             <div className="teamRegForm">
                 <div className="signupHeader">Team Sign Up</div>
                <form onSubmit={this.handleSubmit}>
                    <div className="formFieldsRow">
                        <div className="labelCell">Team Name:</div>
                        <div className="inputCell"><input type="text" value={this.state.teamName} onChange={this.handleTeamNameChange} /></div>
                    </div>
                    <div className="formFieldsRow">
                        <div className="labelCell">Boat Name:</div>
                        <div className="inputCell"><input type="text" value={this.state.boatName} onChange={this.handleBoatNameChange} /></div>
                    </div>
                    <div className="formFieldsRow">
                        <div className="labelCell">Team Captain Name:</div>
                        <div className="inputCell"><input type="text" value={this.state.teamCaptName} onChange={this.handleTeamCaptNameChange} /></div>
                    </div>
                    <div className="formFieldsRow">
                        <div className="labelCell">Team Captain Email:</div>
                        <div className="inputCell"><input type="text" value={this.state.teamCaptEmail} onChange={this.handleTeamCaptEmailChange} /></div>
                    </div>
                    <div className="formFieldsRow">
                        <div className="labelCell">Role: </div>
                          <div className="inputCell">
                            <select value={this.state.role} onChange={this.handleRoleChange}>
                              <option value="quepos">Boat Captain</option>
                              <option value="herradura">Angler</option>
                              <option value="golfito">Other</option>
                            </select></div>
                    </div>
                    <div className="submitBtn">
                        <input type="submit" value="Submit" />
                    </div>
                </form>
             </div>
             </div>
        </PhoneBreakpoint>
      </div> 
    );
  }
}

export default TeamReg;


// WEBPACK FOOTER //
// ./src/pages/TeamReg.js